import React, { FC } from "react";
import { Input, Pagination } from "@pd/pd-ui-kit";
import type { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";

import {
  INACTIVE_DEALERS_PAGE_SIZE,
  useInactiveDealersToAssign,
} from "~/entity/Dealers/hooks/useInactiveDealersToAssign";
import { IDealerToAssign } from "~/entity/Dealers/model/schema";
import { Profile } from "~/schemas/generated/graphql";
import { TableV2 } from "~/shared/ui/TableV2";

import DealerAssignCheckbox from "./DealerAssignCheckbox";

import s from "./UsersDealerForm.less";

interface IProps {
  user?: Profile;
  usersRefetch?;
}

const UsersDealerForm: FC<IProps> = ({ user = {}, usersRefetch }) => {
  const { t } = useTranslation();
  const {
    items,
    totalCount,
    page,
    setPage,
    count,
    onChangeCount,
    search,
    onSearch,
    loading,
    isFetching,
    refetch,
  } = useInactiveDealersToAssign(user.id);

  // У пользователя с ролью "dealer" может быть только один ДЦ:
  // блокируем выбор остальных, пока назначен текущий.
  const isSingleDealer = user.role === "dealer" && items.some((d) => d.isMy);

  const handleAssignCompleted = () => {
    refetch();
    usersRefetch?.();
  };

  const columns: ColumnsType<IDealerToAssign> = [
    {
      title: t("users_dealer_form.inn"),
      dataIndex: "INN",
      key: "INN",
    },
    {
      title: t("users_dealer_form.branch_code"),
      dataIndex: "code",
      key: "code",
    },
    {
      title: t("users_dealer_form.fullname"),
      dataIndex: "DealerName",
      key: "DealerName",
    },
    {
      title: "",
      key: "assign",
      render: (_, dealer) => (
        <DealerAssignCheckbox
          dealer={dealer}
          userId={user.id}
          isDisabled={isSingleDealer && !dealer.isMy}
          onCompleted={handleAssignCompleted}
        />
      ),
    },
  ];

  return (
    <div className={s.form}>
      <div className={s.user_name}>{user.fullname}</div>
      <Input
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        placeholder={t("ui.search")}
        allowClear
      />
      <TableV2
        dataSource={items}
        columns={columns}
        loading={loading || isFetching}
        pagination={false}
        wrapperClassName={s.table}
      />
      <Pagination
        count={count || INACTIVE_DEALERS_PAGE_SIZE}
        page={page + 1}
        totalCount={totalCount}
        onChangeCount={onChangeCount}
        onChangePage={(n: number) => setPage(Math.max(0, (n || 1) - 1))}
      />
    </div>
  );
};

export default UsersDealerForm;
